export class Company {
  id: number;
  country: string;
  name?: string;
  org_no?: string;
  invoicing_currency?: string;

  constructor(company: Company) {
    this.id = company.id;
    this.name = company.name;
    this.org_no = company.org_no;
    this.invoicing_currency = company.invoicing_currency
      ? company.invoicing_currency.toLowerCase()
      : 'sek';
    this.country = company.country;
  }
}
